/* Schimba toate culorile cu complementarul lor in dark theme */
const darkTheme = {
  palette: {
    type: 'dark',
    background: {
      default: '#11151c',
      paper: '#21262D',
    },
    clrAccent: '#161B22',
    clrHover: {
      main: '#fafafa',
    },
    clrReddit: '#ff4500',
  },
};

export default darkTheme;
